
/* === A/B TEST: Hero Landing Pages === */
(function() {
  var SECTION_A = 'image_with_text_overlay_CM8qqT';
  var SECTION_B = 'image_with_text_overlay_kEH3kV';
  var COOKIE_NAME = 'aqln_ab_hero';
  var COOKIE_DAYS = 30;

  /* Inject CSS immediately to hide both sections (prevents flash) */
  var hideStyle = document.createElement('style');
  hideStyle.id = 'aqln-ab-hide';
  hideStyle.textContent = '[id*="' + SECTION_A + '"],[id*="' + SECTION_B + '"] { display: none !important; }';
  document.head.appendChild(hideStyle);

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  var variant = getCookie(COOKIE_NAME);
  if (!variant || (variant !== 'A' && variant !== 'B')) {
    variant = Math.random() < 0.5 ? 'A' : 'B';
    setCookie(COOKIE_NAME, variant, COOKIE_DAYS);
  }

  function showVariant() {
    var showId = variant === 'A' ? SECTION_A : SECTION_B;
    var hideId = variant === 'A' ? SECTION_B : SECTION_A;
    var oldStyle = document.getElementById('aqln-ab-hide');
    if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);
    var keepStyle = document.createElement('style');
    keepStyle.textContent = '[id*="' + hideId + '"] { display: none !important; }';
    document.head.appendChild(keepStyle);
    window.aqln_ab_variant = variant;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showVariant);
  } else {
    showVariant();
  }
})();
/* === END A/B TEST === */
/* === A/B TRACKING URLs === */
(function() {
  var SECTION_A = "image_with_text_overlay_CM8qqT";
  var SECTION_B = "image_with_text_overlay_kEH3kV";

  function tagPageAndLinks() {
    var v = window.aqln_ab_variant;
    if (!v) return;
    var ref = v === "B" ? "hero_b" : "hero_a";

    /* Tag the homepage URL so Shopify records landing_page_path = /?ref=hero_a or /?ref=hero_b */
    if (window.location.pathname === "/" && window.location.search.indexOf("ref=hero") === -1) {
      var sep = window.location.search ? "&" : "?";
      var newUrl = window.location.pathname + sep + "ref=" + ref + window.location.hash;
      try { history.replaceState(null, "", newUrl); } catch(e) {}
    }

    /* Also update CTA links inside hero sections */
    var sA = document.querySelector("[id*=" + SECTION_A + "]");
    var sB = document.querySelector("[id*=" + SECTION_B + "]");
    var sections = [sA, sB];
    for (var s = 0; s < sections.length; s++) {
      if (!sections[s]) continue;
      var links = sections[s].querySelectorAll("a");
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.href) {
          var base = a.href.split("?")[0];
          a.href = base + "?ref=" + ref;
        }
      }
    }
    /* Also update the ux-hero-cta overlay if present */
    var overlay = document.getElementById("ux-hero-cta");
    if (overlay) {
      var oLinks = overlay.querySelectorAll("a");
      for (var j = 0; j < oLinks.length; j++) {
        if (oLinks[j].href) {
          var oBase = oLinks[j].href.split("?")[0];
          oLinks[j].href = oBase + "?ref=" + ref;
        }
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { setTimeout(tagPageAndLinks, 300); });
  } else {
    setTimeout(tagPageAndLinks, 300);
  }
})();
/* === END A/B TRACKING URLs === */

/* AQL&NAFS UX Funnel Optimization */
// (function(){'use strict';var S=document.createElement('style');S.textContent='.ux-trust-row{display:flex;flex-wrap:wrap;gap:16px;justify-content:center;padding:20px 0 8px;margin-top:16px;border-top:1px solid transparent}.ux-trust-item{display:flex;align-items:center;gap:8px;font-size:11px;font-weight: 700; letter-spacing:0.12em;text-transform:uppercase;color:#555}.ux-trust-item svg{flex-shrink:0;opacity:0.7}@media(max-width:740px){.ux-trust-row{gap:10px;padding:16px 0 4px}.ux-trust-item{font-size:10px}}#ux-value-bar{background: rgba(0,0,0,0.3);color: #ffffff;padding:10px 0;font-size:11px;font-weight: 700; letter-spacing:0.14em;text-transform:uppercase;text-align:center;overflow:hidden}#ux-value-bar .vb-inner{display:flex;justify-content:center;gap:32px;flex-wrap:wrap}#ux-value-bar .vb-item{display:flex;align-items:center;gap:8px;white-space:nowrap}#ux-value-bar svg{opacity:0.8}@media(max-width:740px){#ux-value-bar .vb-inner{gap:16px;padding:0 12px}#ux-value-bar{font-size:9px;padding:8px 0}}#ux-cart-trust{padding:12px 16px;border-top:1px solid transparent;text-align:center;font-size:10px;font-weight: 700; letter-spacing:0.1em;text-transform:uppercase;color:#777;line-height:1.8}#ux-hero-cta.ux-hero-overlay{position:absolute!important;top:0!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;height:100%!important;max-width:none!important;display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:flex-end!important;padding-bottom:0!important;text-align:center;z-index:5!important;background:linear-gradient(180deg,transparent 0%,transparent 100%)!important;box-sizing:border-box!important}.ux-hero-btns{display:flex;gap:16px;flex-wrap:wrap;justify-content:center;margin-bottom:20%}.ux-hero-btns a{display:inline-block;padding:14px 36px;font-size:12px;font-weight: 700; letter-spacing:0.2em;text-transform:uppercase;text-decoration:none;transition:all 0.3s ease}.ux-btn-outline{background: rgba(0,0,0,0.3);color: #ffffff;border:2px solid #ffffff}.ux-btn-outline:hover{background: rgba(0,0,0,0.3);color: #ffffff}.ux-btn-secondary{background: rgba(0,0,0,0.3);color: #ffffff;border:2px solid rgba(255,255,255,0.7)}.ux-btn-secondary:hover{background: rgba(0,0,0,0.3);color: #ffffff;border-color: #ffffff}@media(max-width:740px){.ux-hero-btns a{padding:12px 28px;font-size:11px}.ux-hero-btns{margin-bottom:42%}}.shopify-section--announcement-bar{display:none!important}';document.head.appendChild(S);var b=document.querySelector('.buy-buttons');if(b&&!document.getElementById('ux-trust-signals')){var r=document.createElement('div');r.id='ux-trust-signals';r.className='ux-trust-row';r.innerHTML='<div class="ux-trust-item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>Free Worldwide Shipping</div><div class="ux-trust-item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>Secure Checkout</div><div class="ux-trust-item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 000-7.78z"/></svg>Handmade With Love</div><div class="ux-trust-item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg>Easy Returns</div>';b.parentNode.insertBefore(r,b.nextSibling)}var h=document.querySelector('.shopify-section--header');if(h&&!document.getElementById('ux-value-bar')){var v=document.createElement('div');v.id='ux-value-bar';v.innerHTML='<div class="vb-inner"><span class="vb-item">Handmade in Afghanistan</span><span class="vb-item">Secure Checkout</span><span class="vb-item">Free Worldwide Shipping</span><span class="vb-item">Free Returns</span></div>';h.parentNode.insertBefore(v,h)}var hero=document.querySelector('.shopify-section--image-with-text-overlay');if(hero&&!document.getElementById('ux-hero-cta')){var cm=hero.querySelector('.content-over-media');if(cm){cm.style.position='relative';var ov=document.createElement('div');ov.id='ux-hero-cta';ov.className='ux-hero-overlay';ov.innerHTML='<div class="ux-hero-btns"><a href="/collections" class="ux-btn-outline">SHOP NOW</a></div>';cm.appendChild(ov);var ct=hero.querySelector('.content');if(ct){ct.style.display='none'}}}var o=new MutationObserver(function(){var d=document.querySelector('cart-drawer,.cart-drawer');if(!d||d.querySelector('#ux-cart-trust'))return;var f=d.querySelector('[class*="cart__footer"]');if(!f)return;var t=document.createElement('div');t.id='ux-cart-trust';t.textContent='Secure Checkout \u2022 Free Worldwide Shipping \u2022 Handmade Quality';f.parentNode.insertBefore(t,f)});o.observe(document.body,{childList:true,subtree:true});})();

/* AQL&NAFS Performance Optimizations */
(function(){'use strict';
var fontFix=document.createElement('style');
fontFix.textContent='@font-face{font-family:"Instrument Sans";font-display:swap!important}@font-face{font-family:"Nunito";font-display:swap!important}';
document.head.appendChild(fontFix);
function optimizeImages(){
  var imgs=document.querySelectorAll('img');
  var vpH=window.innerHeight;
  imgs.forEach(function(img){
    var rect=img.getBoundingClientRect();
    if(rect.top<vpH&&rect.bottom>0&&rect.width>300){
      img.setAttribute('fetchpriority','high');
      img.removeAttribute('loading');
      img.setAttribute('decoding','async');
    }else if(rect.top>=vpH){
      if(!img.hasAttribute('loading')){img.setAttribute('loading','lazy');}
      img.setAttribute('decoding','async');
    }
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',optimizeImages);}else{optimizeImages();}
function deferThirdParty(){
  var scripts=document.querySelectorAll('script[src*="tagembed"],script[src*="tawk"],script[src*="tidio"]');
  scripts.forEach(function(s){
    if(s.hasAttribute('async')&&!s.dataset.deferred){
      var parent=s.parentNode;var src=s.getAttribute('src');
      s.dataset.deferred='true';parent.removeChild(s);
      if('requestIdleCallback' in window){requestIdleCallback(function(){var ns=document.createElement('script');ns.src=src;ns.async=true;document.body.appendChild(ns);},{timeout:3000});}
      else{setTimeout(function(){var ns=document.createElement('script');ns.src=src;ns.async=true;document.body.appendChild(ns);},2000);}
    }
  });
}
deferThirdParty();
var preconnects=['https://widget.tagembed.com','https://fonts.googleapis.com','https://cdn.shopify.com'];
preconnects.forEach(function(url){
  if(!document.querySelector('link[rel="preconnect"][href="'+url+'"]')){
    var link=document.createElement('link');link.rel='preconnect';link.href=url;link.crossOrigin='anonymous';document.head.appendChild(link);
  }
});
function deferNonCriticalCSS(){
  var links=document.querySelectorAll('link[rel="stylesheet"]');
  links.forEach(function(link){
    var href=link.getAttribute('href')||'';
    if(href.indexOf('tagembed')>-1||href.indexOf('tawk')>-1||href.indexOf('tidio')>-1){
      link.media='print';link.onload=function(){this.media='all';this.onload=null};
    }
  });
}
deferNonCriticalCSS();
})();

/* AQL&NAFS Collection Description Teaser */
(function(){'use strict';
var desc=document.querySelector('.collection-description');
if(!desc||desc.children.length===0)return;

var ts=document.createElement('style');
ts.textContent='.cd-teaser{position:relative;max-height:4.5em;overflow:hidden;transition:max-height 0.4s ease}.cd-teaser::after{content:"";position:absolute;bottom:0;left:0;right:0;height:1.8em;background:linear-gradient(to bottom,rgba(247,247,247,0) 0%,rgba(247,247,247,0.85) 60%,rgba(247,247,247,1) 100%);pointer-events:none;transition:opacity 0.3s ease}.cd-teaser.is-open{max-height:2000px}.cd-teaser.is-open::after{opacity:0}.cd-load-more{display:block;margin:8px auto 0;padding:4px 0;background:none;border:none;cursor:pointer;font-size:11px;font-weight: 700; letter-spacing:0.14em;text-transform:uppercase;color:#888;font-family:inherit;transition:color 0.2s ease}.cd-load-more:hover{color: #ffffff}';
document.head.appendChild(ts);

desc.classList.add('cd-teaser');

var btn=document.createElement('button');
btn.className='cd-load-more';
btn.textContent='Load more';
btn.setAttribute('aria-expanded','false');
desc.parentNode.insertBefore(btn,desc.nextSibling);

btn.addEventListener('click',function(){
  var isOpen=desc.classList.toggle('is-open');
  btn.textContent=isOpen?'Show less':'Load more';
  btn.setAttribute('aria-expanded',isOpen?'true':'false');
});
})();